import PaymentWizard from './PaymentWizard';

export default PaymentWizard;
